import {
  HAWKES_BLUE,
  LUCKY_POINT,
  LUCKY_POINT_DARK
} from "../../../constants/colors";

const selectedColor = `${LUCKY_POINT}`;
const hoverColor = `${HAWKES_BLUE}`;
const focusColor = `${LUCKY_POINT_DARK}`;

export const fallbackValues = {
  selectedColor,
  hoverColor,
  focusColor
};
